import React, { Component } from 'react';
import $ from 'jquery';
import config from "../config";
import { gapi } from 'gapi-script';
import axios from 'axios';
import moment from 'moment';
import { ulid } from 'ulid';

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Button, TextField, Table, TableSortLabel, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import {DebounceInput} from 'react-debounce-input';

export default class MongoDBMdsManager extends Component {
	
	constructor(props){
        super(props)
		this.state ={
			mdsJsonFilesVersion:new Map(),
			filesExist:false,
			page:0,
			rowsPerPage:10,
			filterMode:'',
			searchQuery:'',
			mdsSheets:[],
			mdsSheets2:[],
			staticIDMissed:[],
			missedMDSName:'',
			missedGuid:'',
			stMDSGuid:'',
		}

    }
	
	componentDidMount() {
		let that = this;
		//that.checkMdsFields();
		that.getMdsSheetsFromPostgres();
		setTimeout(function(){
			that.setState({mdsSheets:that.props.mdsSheets});
		}, 1000);
		//setInterval(this.checkFiles, 3000);
		
	}
	
	/* componentDidUpdate() {
		let that = this;
		setTimeout(function(){
			that.setState({mdsSheets:that.props.mdsSheets});
		}, 1000);
	} */
	
	getValue=(event)=>{
		let name = event.target.name;
		let res = event.target.value;
		this.setState({[event.target.name]:event.target.value});
		let that = this;
		if(name == 'filterMode'){
			setTimeout(function(){
				that.filterMdsForms();
			}, 1000);
		}
		
		if(name == 'selectedInstance'){
			this.props.getValue2(event);
			setTimeout(function(){
				that.setState({mdsSheets:that.props.mdsSheets});
				that.getMdsJsonFileVersion();
			}, 2000);
		}
	}
	
	getMdsSheetsFromPostgres=() => {
		//let ApiUrl = config.mongoApiUrl;
		let url = 'https://api.123456testmysite.com/mds-forms';
		let assignedMdsFiles = localStorage.getItem('assignedMdsFiles') ? localStorage.getItem('assignedMdsFiles').split(','): [];
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
            const sheets = response.data;
			let mdsSheets2 = sheets.map((sheet) =>{
				let sheetTitle = sheet.MDSName;
				if(sheetTitle.indexOf('Temp-') == -1){
					return sheet;
				}
			});
			
			mdsSheets2 = mdsSheets2.filter(function(x) {
				 return x !== undefined;
			});
			this.setState({mdsSheets2});
        })
	}
	
	handleSearch = (event) => {
		let that = this;
		this.setState({searchQuery:event.target.value});
		setTimeout(function(){
			that.filterMdsForms();
		}, 1000);
    };

	filterMdsForms=()=>{
		let mdsSheets = this.props.mdsSheets;
		let mdsForms = [];
		mdsSheets.map((sheet,i)=>{
			if(this.state.filterMode && this.state.filterMode != sheet.Mode){
				return false;
			}
			if(sheet.Fields){
				sheet['type'] = sheet.Fields[1][92];
				sheet['dtype'] = sheet.Fields[1][94];
				sheet['vtype'] = sheet.Fields[1][95];
				sheet['anatomy'] = sheet.Fields[1][96];
				
				let visibleTxt = [];
				let outputTxt = [];
				sheet.Fields.map((txt,i)=>{
					if(i > 0){
						if(txt[4]){
							visibleTxt.push(txt[4]);
						}
						if(txt[9]){
							outputTxt.push(txt[9]);
						}
					}
				});
				
				sheet['visibleTxt'] = visibleTxt.join(',');
				sheet['outputTxt'] = outputTxt.join(',');
			}
			mdsForms.push(sheet);
		});
		
		let searchQuery = this.state.searchQuery;
		
		if(searchQuery){
			mdsForms = mdsForms.filter((row) =>
				row.MDSName.toLowerCase().includes(searchQuery.toLowerCase()) ||
				row.Mode.toLowerCase().includes(searchQuery.toLowerCase()) ||
				row.Version && row.Version == searchQuery ||
				row.visibleTxt && row.visibleTxt.toLowerCase().includes(searchQuery.toLowerCase()) ||
				row.outputTxt && row.outputTxt.toLowerCase().includes(searchQuery.toLowerCase()) ||
				row.type && row.type.toLowerCase().includes(searchQuery.toLowerCase()) ||
				row.dtype && row.dtype.toLowerCase().includes(searchQuery.toLowerCase()) ||
				row.vtype && row.vtype.toLowerCase().includes(searchQuery.toLowerCase()) ||
				row.anatomy && row.anatomy.toLowerCase().includes(searchQuery.toLowerCase())
			);
		}
		//console.log('mdsForms->',mdsForms);
		this.setState({mdsSheets:mdsForms});
	}
		
	checkFiles=()=>{
		
		if(this.state.filesExist == false){
		   this.getMdsJsonFileVersion();
		}
	   
		if(this.props.mdsSheets){
		   this.setState({filesExist:true});
		}
	}
	
	getMdsJsonFileVersion=()=>{
		let mdsSheetGuids = [];
		
		this.props.mdsSheets.map((sheet,i)=>{
			mdsSheetGuids.push(sheet.MDSGuid);
		});
		
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'mds-json-version-v2';
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(mdsSheetGuids),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let files = response.data;
			if(files.length > 0){
				files.map((file,i)=>{
					if(file.Version){
						let mdsJsonFilesVersion = this.state.mdsJsonFilesVersion;
						mdsJsonFilesVersion.set(file.MDSGuid,file.Version);
						this.setState({mdsJsonFilesVersion});
					}
				});
			}
			
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	changeFileMode=(event)=>{
		let value = event.target.value;
		let guid = event.target.id;
		let staticIDMissed = this.state.staticIDMissed;
		
		let missed = false;
		if(staticIDMissed.length > 0){
			staticIDMissed.map((val,i) =>{
				if(val.MDSGuid == guid){
					missed = true;
				}
			})
		}
		
		if(missed && value == 'Prod'){
			alert('The MDS has missing staticFieldID or staticFieldIdentifier.');
			return false;			
		}
		
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'update-Mds-mode';
		let data = {
			"MDSGuid": guid,
			"Mode": value,
		}
		axios({
			method: 'POST',
			url: url,
			data: data,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			
			let logData = [];
			this.state.mdsSheets.map((sheet) =>{
				if(sheet.MDSGuid == guid){
					logData = {
						"Form": 'MDS',
						"FormGuid": guid,
						"FormName": sheet.MDSName,
						"Status": value,
						"Action": 'Status Changed',
						"Created": moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
					}
				}
			})
			this.props.auditLog(logData);
			
			//if(value == 'Prod'){
				//this.uploadLayoutJsonMongoDb(sheetName);
				let that = this;
				that.props.getMdsSheets(that.props.selectedInstanceId);
				setTimeout(function(){
					that.filterMdsForms();
					that.getMdsJsonFileVersion();
				}, 3000);
			//}
			this.setState({['mode-'+guid]:value});
			//console.log('response::', response);
		}).catch(error => {
			console.log('error::', error);
		})

	}
	
	handleChangePage = (event: unknown, newPage: number) => {
		this.setState({page:newPage});
		let that = this;
		setTimeout(function(){
			//that.checkMdsFields();
		}, 1000);
		
	};

	handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		this.setState({rowsPerPage:event.target.value,page:0});
	};
	
	handleSort = column => {
		const { sortBy, sortOrder } = this.state;
		const isAsc = sortBy === column && sortOrder === 'asc';
		this.setState({
		  sortBy: column,
		  sortOrder: isAsc ? 'desc' : 'asc'
		});
	};
	
	/* downloadExcel=(sheetName) => {
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'mds-file/'+sheetName;
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
            const data = response.data;
            const fileName = response.data.MDSName;
			if(data.Fields){
				//const worksheet = XLSX.utils.json_to_sheet(data.Fields);
				const worksheet = XLSX.utils.aoa_to_sheet(data.Fields);
				const workbook = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
				const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
				const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
				saveAs(blob, `${fileName}.xlsx`);
			}
        })
    } */
	
	newDownloadExcel=(sheetGuid) => {
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'mds-json-v2/'+sheetGuid;
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
            let data = response.data;
			let fileName = response.data.MDSName;
			let fieldData = [
				["MDSGuid",data.MDSGuid],
				["MDSName",data.MDSName],
				["CreatedDate",data.CreatedDate],
				["ModifiedDate",data.ModifiedDate],
				["Version",data.Version],
				["Mode",data.Mode],
				["CreatedBy",data.CreatedBy],
				["",""],
				["FieldGUID","MasterDataSetGUID","FieldName","FieldNameIdentifier_STATIC","VisibleText","OutputText","FieldType","PrefilterDelegates","FieldTypeOptions","Notes","InternalDataPersistenceLabel","Tags","DataAgg","AutoTags","ValidationType","DataElement","CreatedDate","ModifiedDate","FieldRegistry","BuilderNote","IsActive","Translations"]
			]
			
			let fields = [];
			if(data.Fields){
				data.Fields.map((val,i) =>{
					let delegates = [];
					if(val.PrefilteredDelegates){
						val.PrefilteredDelegates.map((del,i) =>{
							delegates.push(del.delegate);
						});
						delegates = delegates.join();
					}
					let options = [];
					if(val.FieldTypeOptions && val.FieldTypeOptions.Options){
						if(val.FieldTypeOptions.Options.length > 0){
							val.FieldTypeOptions.Options.map((op,i) =>{
								if(val.FieldType == 'hidden'){
									let opArr = op.split('|');
									options.push(opArr[1]);
								}else{
									if(op.OPIE_ENUM){
										let opt = op.option +'|'+ op.OPIE_ENUM;
										options.push(opt);
									}else{
										options.push(op.option);
									}

								}
							});
							options = options.join();
						}
					}
					
					if((val.FieldType == 'basicgrid' || val.FieldType == 'basicgrid2' || val.FieldType == 'grid5point' || val.FieldType == 'grid-dropdown' || val.FieldType == 'grid-singlecheck' || val.FieldType == 'grid-multicheck' || val.FieldType == 'likert' || val.FieldType == 'gridcheck') && val.FieldTypeOptions && val.FieldTypeOptions.GridLabelValue){
						let str = [];
						if(val.FieldTypeOptions.GridLabelValue && val.FieldTypeOptions.GridLabelValue.ColumnLabelValues.length > 0){
							val.FieldTypeOptions.GridLabelValue.ColumnLabelValues.map((glv,i) =>{
								if(val.FieldType == 'gridcheck'){
									let opArr = glv.label.split('|');
									str.push(opArr[1]);
								}else{
									str.push(glv.label);
								}
								
							});
							str = str.join();
						}
						let str2 = [];
						if(val.FieldTypeOptions.GridLabelValue && val.FieldTypeOptions.GridLabelValue.RowLabelValues.length > 0){
							val.FieldTypeOptions.GridLabelValue.RowLabelValues.map((rlv,i) =>{
								str2.push(rlv.label);
							});
							str2 = str2.join();
						}
						options = str+'|'+str2;
					}
					
					let fld = [val.FieldGUID,val.MasterDataSetGUID,val.FieldName,val.FieldNameIdentifier_STATIC,val.VisibleText,val.OutputText,val.FieldType,delegates,options,val.Notes,val.InternalDataPersistenceLabel,val.Tags,val.DataAgg,val.AutoTags,val.ValidationType,val.DataElement,val.CreatedDate,val.ModifiedDate,val.FieldRegistry,val.BuilderNote,val.IsActive,val.Translations];
					fld = fld.map(value => value === undefined ? '' : value);
					fields.push(fld);
				});
				
				let allData = fieldData.concat(fields);	
				if(allData){
					//const worksheet = XLSX.utils.json_to_sheet(fieldData);
					const worksheet = XLSX.utils.aoa_to_sheet(allData);
					const workbook = XLSX.utils.book_new();
					XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
					const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
					const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
					saveAs(blob, `${fileName}.xlsx`);
				}
			}
        })
    }
	
	checkMdsFields=() => {
		let staticIDMissed = this.state.staticIDMissed;
		this.setState({staticIDMissed:[],missedGuid:''});
		let mdsToCheck = this.state.page * this.state.rowsPerPage;
		let limit = this.state.page * this.state.rowsPerPage + 10;
		let mdsSheetGuids = [];
		this.props.mdsSheets.map((sheet,i)=>{
			if(i >= mdsToCheck && i < limit){
				mdsSheetGuids.push(sheet.MDSGuid);
			}
		});
		
		if(mdsSheetGuids){
			let mongoApiUrl = config.mongoApiUrl;
			let url = mongoApiUrl+'mds-check-fields';
			axios({
				method: 'POST',
				url: url,
				data: JSON.stringify(mdsSheetGuids),
				headers: {
					'Content-Type': 'application/json',
				}
			})
			.then(response => {
				let files = response.data;
				let missedData = [];
				files.map((val,i) =>{
					let mdsGuid = val.MDSGuid;
					let MDSName = val.MDSName;
					let mdsFields = val.Fields;
					mdsFields.map((vl,n) =>{
						if(n > 0 && (vl[63] == '' || vl[61] == '')){
							let field ={
								"MDSGuid": mdsGuid,
								"FieldGuide": vl[117],
								"FieldID": vl[0],
								"VisibleText": vl[4],
							}
							missedData.push(field);
						}
					})
				})
				this.setState({staticIDMissed:missedData});
			}).catch(error => {
				console.log('error::', error);
			})
		}
	}
	
	showMissedFields=(MDSGuid,MDSName) => {
		this.setState({missedGuid:MDSGuid,missedMDSName:MDSName});
		$('#showMissedFields').modal('show');
	}
	
	getStaticIDGuid=(MDSGuid) => {
		this.setState({stMDSGuid:MDSGuid});
		//$('#enterPrefix').modal('show');
	}
	
	updateStaticIDs=() => {
		let stMDSGuid = this.state.stMDSGuid;
		let MDSPrefix = this.state.MDSPrefix;
		if(stMDSGuid && MDSPrefix){
			
			let ApiUrl = config.mongoApiUrl;
			let url = ApiUrl+'mds-files-static';
			let formData = new FormData();
			formData.append('MDSGuid', stMDSGuid);
			formData.append('MDSPrefix', MDSPrefix);
			axios({
				method: 'POST',
				url: url,
				data: formData,
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
			.then(response => {
				this.checkMdsFields();
				alert('The form updated successfully!');
			})
		}
	}
	
	getUplaodPostgres=(sheet) => {
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'mds-file/'+sheet;
		//let url = ApiUrl+'mds-file/All-Plan-Treatment4x4';
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
            const data = response.data;
			//console.log('data->',data);
			let allData = [];
			let fields = data['Fields'];
			let f2Fields = [];
			let dates = [];
			if(fields){
				fields.map((field,i)=>{
					if(i > 0){
						let date = new Date(field[98]);
						if(date != 'Invalid Date'){
							dates.push(date);
						}
						allData.push(field);
						
						let newField = {
							"FieldGUID": field[117],
							"PerantFieldGUID": field[11],
							"MasterDataSetGUID":response.data.MDSGuid,
							"FieldName":field[0],
							"Field#":field[1],
							"Parent#":field[2],
							"Include":field[14],
							"Require":field[15],
							"Kiosk":field[37],
							"StaticFieldID":field[63],
							"FieldAltText":field[64],
							"Position":field[10],
							"FieldNameIdentifier_STATIC":field[61],
							"VisibleText":field[4],
							"FieldType":field[5],
							"Options":field[6],
							"GridLabelValue":field[41],
							"PrefilteredDelegates":['CPO'],
							"ButtonLabel":field[40],
							"VisibleTxtBoxLabel":field[45],
							"OutputTxtBoxLabel":field[46],
							"ImageLocationReferenceInfo":field[99],
							"OutputText":field[9],
							"Notes":field[12],
							"InternalDataPersistenceLabel": field[110],
							"Tags":field[13],
							"DataAgg":field[3],
							"AutoTags":field[106],
							"ValidationType":field[48],
							"LeftGridLabel":field[53],
							"CalculationType":field[113],
							"CalculationFields":field[114],
							"DataLowLimit":field[50],
							"DataHighLimit":field[51],
							"NumberOfGrid":field[136] ? field[136] : '',
							"NumberOfRow":field[137] ? field[137] : '',
							"Arraignment":field[138] ? field[138] : '',
							"StepValue":field[36],
							"OptionSorting": field[69] ? field[69] : false,
							"DataElement":field[100],
							"DataElementOption":field[101],
							"AnalysisVideo":field[5] == 'apivideo' ? field[59] : '',
							"ConditionalFieldGUID":'',
							"ReportPdf":'',
							"MinOptionSelection": field[30] ? field[30] : '',
							"MaxOptionSelection": field[31] ? field[31] : '',
							"WebLink":field[78],
							"AsGroup":field[127] ? field[127] : '',
							"ResponseDataFormat":field[102],
							"FieldRegistry":field[57],
							"BuilderNoteField":field[58],
							"FieldInternalNote":field[56],
							"CreatedDate": field[97],
							"ModifiedDate": field[98],
							"IsActive":field[60],
							"Translations": false,
						}
						f2Fields.push(newField)
					}
				});
			}
			
			if(allData.length > 0){
				//let mdsCompany = allData[0][115];
				let mdsFacility = allData[0][120];
				//let mdsGroupId = allData[0][121];
				let allDelegate = allData[0][119]; 
				let allTypes = allData[0][92]; 
				let allDeviceTypes = allData[0][94]; 
				let allVisitTypes = allData[0][95];
				
				let mdsGuid = response.data.MDSGuid;
				let version = response.data.Version;
				let MDSName = response.data.MDSName;
				let InstanceName = response.data.InstanceName;
				let InstanceGuild = response.data.InstanceGuild;
				let mode = response.data.Mode;
				let CreatedBy = response.data.CreatedBy;
				let CreatedDate = response.data.CreatedDate;
				let ModifiedDate = response.data.ModifiedDate;
				
				let MDSFile ={
					"MDSGuid": mdsGuid,
					"MDSName": MDSName,
					"InstanceName": InstanceName ? InstanceName : this.props.selectedInstanceName,
					"InstanceGuid": InstanceGuild  ? InstanceGuild : this.props.selectedInstanceId,
					"FacilityID": mdsFacility,
					"allDelegate": allDelegate,
					"AssociatedType": allTypes,
					"AssociatedDeviceTypes": allDeviceTypes,
					"AssociatedVisitTypes": allVisitTypes,
					"CreatedDate": CreatedDate,
					"ModifiedDate": ModifiedDate,
					'Version': version,
					"Mode": mode,
					"CreatedBy": CreatedBy,
					'Fields': f2Fields,
				}
				
				if(MDSFile){
					axios({
						method: 'POST',
						//url: 'http://localhost:8000/insert-mds',
						url: 'https://api.123456testmysite.com/insert-update-mds',
						data: JSON.stringify(MDSFile),
						headers: {
							'Content-Type': 'application/json',
						}
					})
					.then(response => {
						//this.getMdsSheetsFromPostgres();
						alert('MDS sent to Postgres!');
					}).catch(error => {
						console.log('error::', error);
					})
				}
				
				console.log('MDSFile->',MDSFile);
			}
        })
		
    }
	

	render() {
		const {mdsSheets2,mdsJsonFilesVersion,layoutFriendlyName,selectedFiles,sortBy,sortOrder,mdsSheets,searchQuery,staticIDMissed,missedGuid,missedMDSName,stMDSGuid} = this.state;
		console.log('mdsSheets2->',mdsSheets2);
		let FieldsCount = 0;
		let role = localStorage.getItem('role');
		const StyledTableCell = styled(TableCell)(({ theme }) => ({
		  [`&.${tableCellClasses.head}`]: {
			//backgroundColor: '#e9e9e9',
			color: '#000;',
			padding: '15px 5px;',
			fontWeight: 600,
			fontSize: 15,
		  },
		  [`&.${tableCellClasses.body}`]: {
			fontSize: 16,
			backgroundColor: '#ffffff',
		  },
		}));
		
		const sortedData = [...mdsSheets].sort((a, b) => {
		  const isAsc = sortOrder === 'asc';
		  if (a[sortBy] < b[sortBy]) {
			return isAsc ? -1 : 1;
		  }
		  if (a[sortBy] > b[sortBy]) {
			return isAsc ? 1 : -1;
		  }
		  return 0;
		});
		
		let optionInstance = '';
		if(this.props.instances){
			let ins = this.props.instances;
			optionInstance = ins.map(function(val,i) {
				return (
						<MenuItem value={val.InstanceGuild} key={i}>{val.InstanceName}</MenuItem>
					);
			})
		}
		
		let missedDataTable = '';
		let that = this;
		if(staticIDMissed && missedGuid){
			missedDataTable = staticIDMissed.map(function(val,i) {
				if(missedGuid == val.MDSGuid){
					return (
						<tr key={i}><td className="v-list">{val.FieldGuide}</td><td className="v-list">{val.FieldID}</td><td className="v-list">{val.VisibleText}</td></tr>
					);
				}
			})
		}
		
		return (
			<div className="mds-manager-mongo custom-container">
				<div className="mongo-header">
					<div className="mg-page-title"><h4>MongoDB MDS Manager</h4></div>
					{/* <div className="wp-check-filter">
						<button type="button" onClick={()=>this.checkMdsFields()} className="btn btn-info">Check MDS</button>
					</div> */}
					<div className="wp-mode-filter">
						<FormControl sx={{ m: 1, minWidth: 155, maxWidth: 250 }} size="small">
							<InputLabel>Select Mode</InputLabel>
							<Select
								value={this.state.filterMode ? this.state.filterMode : ""}
								name={'filterMode'}
								onChange={this.getValue}
								input={<OutlinedInput label="Select Mode" />}
							>
							<MenuItem value={''} >Select Mode</MenuItem>
							<MenuItem value={'Build'} >Build</MenuItem>
							<MenuItem value={'Test'} >Test</MenuItem>
							<MenuItem value={'Dev-Prod'} >Dev-Prod</MenuItem> 
							<MenuItem value={'Prod'} >Prod</MenuItem>
							
							</Select>
						</FormControl>
					</div>
					
					<div className="wp-mode-filter">
						<FormControl sx={{ m: 1, minWidth: 235, maxWidth: 235 }} size="small">
							<InputLabel>Select Instance</InputLabel>
							<Select
								value={this.props.selectedInstanceId}
								name={'selectedInstance'}
								onChange={this.getValue}
								input={<OutlinedInput label="Select Instance" />}
							>
							{optionInstance}
							</Select>
						</FormControl>
					</div>
					
					<div className="wp-search-filter">
							{/* <TextField
								label="Search"
								size="small"
								variant="outlined"
								fullWidth
								value={searchQuery}
								onChange={this.handleSearch}
								style={{ width: '200px' }}
							/> */}
							<DebounceInput debounceTimeout={500} type="text" className="form-control" name="searchQuery" value={searchQuery} onChange={this.handleSearch} placeHolder="Search" />
							<span className="search-icon"><i className="fa fa-search" aria-hidden="true"></i></span>
					</div>
					
					
					
				</div>
				
				{mdsSheets ?
				<div className="mg-child-sheets">
				<TableContainer>
				  <Table size="small" aria-label="a dense table">
					<TableHead>
					  <TableRow key={11}>
						<StyledTableCell>
						<TableSortLabel
							active={sortBy === 'MDSName'}
							direction={sortOrder}
							onClick={() => this.handleSort('MDSName')}
						>
						MDS Name
						</TableSortLabel>
						</StyledTableCell>
						<StyledTableCell>
						<TableSortLabel
							active={sortBy === 'ModifiedDate'}
							direction={sortOrder}
							onClick={() => this.handleSort('ModifiedDate')}
						>
						Last Updated
						</TableSortLabel>
						</StyledTableCell>
						<StyledTableCell>Mode</StyledTableCell>
						<StyledTableCell>F2 Version</StyledTableCell>
						<StyledTableCell>Ver.#</StyledTableCell>
						<StyledTableCell>In PostGres</StyledTableCell>
						<StyledTableCell>PostGres Ver.#</StyledTableCell>
						{role == 'Administrator' ?
						<StyledTableCell>Excel</StyledTableCell>
						:null}
						<StyledTableCell></StyledTableCell>
						
						
					  </TableRow>
					</TableHead>
					<TableBody>
					  {sortedData.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((sheet) => {
						
						let mode = sheet.Mode ? sheet.Mode : 'Test';
						let mongoVersion = mdsJsonFilesVersion.get(sheet.MDSGuid);
						//let friendlyName = layoutFriendlyName.get(sheetGuid);
						
						let classn = 'not-in-mongo';
						if(mongoVersion && (mongoVersion == sheet.Version || sheet.Version == '')){
							classn = 'has-in-mongo';
						}
						let modeValue = sheet.Mode;
						
						let mState = this.state['mode-'+sheet.MDSGuid];
						if(mState){
							modeValue = mState;
						}
						
						FieldsCount = FieldsCount+sheet.FieldsCount;
						let lastUpdate = new Date(sheet.ModifiedDate).toLocaleString("en-US").replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
						let missed = false;
						if(staticIDMissed.length > 0){
							staticIDMissed.map((val,i) =>{
								if(val.MDSGuid == sheet.MDSGuid){
									missed = true;
								}
							})
						}
						let exist = false;
						mdsSheets2.map((row, i) => {
							if(sheet.MDSName == row.MDSName){
								exist = true;
							}
						});
						
						
						return (<TableRow key={sheet.MDSGuid} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
						  <StyledTableCell>{sheet.MDSName}</StyledTableCell>
						  <StyledTableCell>{lastUpdate}</StyledTableCell>
						  <StyledTableCell>
							{missed ?
							<select id={sheet.MDSGuid} className="form-control" value={modeValue} onChange={this.changeFileMode}>
								<option value="Build">Build</option>
								<option value="Test">Test</option>
								<option value="Dev-Prod">Dev-Prod</option>
							</select>
							:
							<select id={sheet.MDSGuid} className="form-control" value={modeValue} onChange={this.changeFileMode}>
								<option value="Build">Build</option>
								<option value="Test">Test</option>
								<option value="Dev-Prod">Dev-Prod</option>
								<option value="Prod">Prod</option>
							</select>
							}
						  </StyledTableCell>
						  <StyledTableCell><i className={"fa fa-circle "+classn} aria-hidden="true"></i></StyledTableCell>
						  <StyledTableCell><i>{sheet.Version && sheet.Version != 1 ? sheet.Version : '1.01' }</i></StyledTableCell>
						  <StyledTableCell><i className={"fa fa-circle not-in-mongo"} aria-hidden="true"></i></StyledTableCell>
						  <StyledTableCell><i>1.01</i></StyledTableCell>
						  {role == 'Administrator' ?
						  <StyledTableCell><i onClick={()=>this.newDownloadExcel(sheet.MDSGuid)} className={"fa fa-file-excel-o"} aria-hidden="true"></i></StyledTableCell>
						  :null}
						  
						  {/* missed ?
						  <StyledTableCell><i onClick={()=>this.showMissedFields(sheet.MDSGuid,sheet.MDSName)} className={"fa fa-commenting-o"} aria-hidden="true"></i></StyledTableCell>
						  :
						  <StyledTableCell></StyledTableCell>
						   */}
						  
						  {/* <StyledTableCell width="150px"><button type="button" data-target="#enterPrefix" data-toggle="modal" className="btn btn-primary static-prefix" onClick={()=>this.getStaticIDGuid(sheet.MDSGuid)}>Enter MDS Prefix</button></StyledTableCell> */}
							{  role == 'Administrator' ?
							<StyledTableCell width="150px"><button type="button" className={exist ? "btn btn-success static-prefix" : "btn btn-primary static-prefix"} onClick={()=>this.getUplaodPostgres(sheet.MDSName)}>{exist ? 'In B3' : 'Send To B3'}</button></StyledTableCell>
							:null }
						  
						</TableRow>)
					  })}
					</TableBody>
				  </Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[5, 10, 20, 50, 100]}
					component="div"
					count={mdsSheets.length}
					rowsPerPage={this.state.rowsPerPage}
					page={this.state.page}
					onPageChange={this.handleChangePage}
					onRowsPerPageChange={this.handleChangeRowsPerPage}
				/>
				
				<div className="modal" id={'enterPrefix'}>
					<div className="modal-dialog modal-lg modal-sm select-modal modal-dialog-2">
						<div className="modal-content">
							<div className="modal-header">
								<h6 className="modal-title">MDS Prefix for StaticFieldID</h6>
								<button type="button" className="close" data-dismiss="modal">&times;</button>
							</div>
							<div className="modal-body">
								<DebounceInput debounceTimeout={4000} type="text" className="form-control"  name="MDSPrefix" onChange={this.getValue} /> 
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-primary float-right" data-dismiss="modal" onClick={()=>this.updateStaticIDs()}>Save</button>
								<button type="button" className="btn btn-danger float-right" data-dismiss="modal">Close</button>
							</div>
						</div>
					</div>
				</div>
				
				<div className="modal" id={'showMissedFields'}>
					<div className="modal-dialog modal-lg modal-sm select-modal modal-dialog-2">
						<div className="modal-content">
							<div className="modal-header">
								<h6 className="modal-title">{missedMDSName} - Static FieldID or Static FieldName is missed! </h6>
								<button type="button" className="close" data-dismiss="modal">&times;</button>
							</div>
							<div className="modal-body ">
								<div className="fl-section-table">
								<table className="table table-bordered">
								<thead>
									<tr>
									  <th>Field Guide</th>
									  <th>Field ID</th>
									  <th>Visible Text</th>
									</tr>
								  </thead>
								<tbody>
								{missedDataTable}
								</tbody>
								</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				
				
				</div>
				:null}
			</div>
		);	
	}	
}
